module.exports = __webpack_public_path__ + "html/opportunity.component.html";